import { Injectable } from '@angular/core';
import {
  MOVESTOCKCART,
  AdpCustomer,
  attributesMap,
  attributesPropertiesMap,
  STOCKCART,
  MOVESTOCKLOCATION
} from '../providers/data';
import { CartPage } from '../pages/cart/cart';
import { Headers, RequestOptions } from '@angular/http';
import {IMAGES_BASE_URL} from './config';

import { Storage } from '@ionic/storage';


import {DomSanitizer} from '@angular/platform-browser';
import { CustomerCarts } from './user-cart-provider/user-carts';
@Injectable()
export class MovestockcartManager {



  public getCust:any ;
  constructor(private storage:Storage,private sanitizer:DomSanitizer){

  }



  setCustomer(customer){

    if(MOVESTOCKCART.customer == null){

      MOVESTOCKCART.customer = customer;
    }else{
      this.clearCartProducts();
      MOVESTOCKCART.customer = customer;
    }
    //alert(JSON.stringify(MOVESTOCKCART));
  }

  // setSalesPerson(user){
  //   MOVESTOCKCART.user = user;
  //   //alert(JSON.stringify(MOVESTOCKCART));
  // }


  // placeOrder(){
  // }

  clearCart(){
    MOVESTOCKCART.items = [];
  }


  addToCartNew(product) {
    if(!Number(product.quantity)){
      product.quantity = 0;
    }

    MOVESTOCKCART.items.push(product);
    this.persistOrderLocal();
  }
  addProductToCart(product) {
    var index= MOVESTOCKCART.items.map(function(x) {return x.productLocationIdWithCode; }).indexOf(product.productLocationIdWithCode);
    if (index != -1) {
      MOVESTOCKCART.items[index].quantity++;
      this.persistOrderLocal();
    } else {
      if (Number(product.quantity) != 0) {
        product.quantity = Number(product.quantity);
      } else {
        product.quantity = 0;
      }
      this.addToCartNew(product);
    }
  }

  // addProductToCartPopup(product) {
  //   product.quantity++;
  //   this.persistOrderLocal();
  //
  //   if (Number(product.quantity) != 0) {
  //     product.quantity = Number(product.quantity);
  //   } else {
  //     product.quantity = 0;
  //   }
  //
  // }

  // update Cart
  updateCartNew(product) {



    if(Number(product.quantity) < Number(product.minOrder)){
      if (Number(product.minOrder) != 0) {
        if (Number(product.quantity) != 0) {
          product.quantity = Number(product.quantity);
        }

      }

    }


    var index= MOVESTOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      //MOVESTOCKCART.items[index].quantity++;
    } else {

      this.addToCartNew(product);
    }
    this.persistOrderLocal();
    //alert(JSON.stringify(MOVESTOCKCART));
  }

  updateCartNewPopup(product) {


    if(Number(product.quantity) < Number(product.minOrder)){
      if (Number(product.minOrder) != 0) {
        if (Number(product.quantity) != 0) {
          product.quantity = Number(product.quantity);
        }

      }

    }


    var index= MOVESTOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      //MOVESTOCKCART.items[index].quantity++;
    } else {

      // this.addToCartNew(product);
    }
    this.persistOrderLocal();
    //alert(JSON.stringify(MOVESTOCKCART));
  }
  // Remove One
  removeOneNew(product) {
    product.quantity--;

  }

  // removeOneNewPopup(product) {
  //   var index= MOVESTOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
  //   if (index != -1) {
  //     MOVESTOCKCART.items[index].quantity--;
  //     this.persistOrderLocal();
  //
  //   }
  // }

  // Remove All
  removeAll(product) {
    var index= MOVESTOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      if(MOVESTOCKCART.items[index].quantity >= 1){
        MOVESTOCKCART.items[index].quantity = 0;
      }
    }
    this.persistOrderLocal();
  }


  // Remove Item
  removeNew(index: number): void {

    MOVESTOCKCART.items.splice(index, 1);
    this.persistOrderLocal();
  }

  deleteProductFromCart(product){
    this.removeAll(product);
    var index= MOVESTOCKCART.items.map(function(x) {return x.productLocationIdWithCode; }).indexOf(product.productLocationIdWithCode);
    if (index != -1) {
      this.removeNew(index);
    }
  }

  genrateOrder(status){
    let total = 0;
    let orderProducts = [];
    let expectedShipmentDate = MOVESTOCKCART.shipDate;
    for(let item of MOVESTOCKCART.items){

      if(this.discountCheck(item.discountPrice)){
        total =  total + (Number(item.discountPrice) * Number(item.quantity));
      }else{
        total =  total + (Number(item.price) * Number(item.quantity));
      }

      var orderDetailDTOs: any = {

        "productsDTO":item,
        "quantity": item.quantity,
        "expectedShipmentDate": expectedShipmentDate,
        "attributeSearch":item.attributeSearch
      };


      orderProducts.push(orderDetailDTOs);
    }

    if(MOVESTOCKCART.customer.locationsDTOs.length>0){
      for(let locationId in MOVESTOCKCART.customer.locationsDTO){
        MOVESTOCKCART.customer.locationsDTO[locationId].createdAt = "";
        MOVESTOCKCART.customer.locationsDTO[locationId].updatedAt = "";
      }
    }

    MOVESTOCKCART.customer.customerJson = "";

    let order = {
      "id":MOVESTOCKCART.orderId,
      "orderTitle": this.getOrderTitle(),
      "salesManId":MOVESTOCKCART.user.id,
      "orderMessage":MOVESTOCKCART.orderMessage,
      "expectedShipmentDate": MOVESTOCKCART.expectedShipmentDate,
      "totalAmount":""+total.toFixed(2),
      "totalTexAmount":"10",
      "orderStatus":status,
      "customerDTO":MOVESTOCKCART.customer,
      "orderDetailDTOs": orderProducts,
      "shippingServiceName":MOVESTOCKCART.shippingServiceName,
      "shippingServiceValue":MOVESTOCKCART.shippingServiceId
    };
    //this.gVLogger.log(JSON.stringify(order));

    return order;

  }

  setLocation(location){
    MOVESTOCKLOCATION.productsLocation = location;
  }

  receiveStock(status, reference, productLocation){
    //alert(JSON.stringify(MOVESTOCKCART));
    // let total = 0;
    // let orderProducts = [];
    // let expectedShipmentDate = MOVESTOCKCART.shipDate;

    var productsDTOList = [];
    for(let item of MOVESTOCKCART.items){
      productsDTOList.push(item);

      // if(this.discountCheck(item.discountPrice)){
      //   total =  total + (Number(item.discountPrice) * Number(item.quantity));
      // }else{
      //   total =  total + (Number(item.price) * Number(item.quantity));
      // }
      //
      // item.quantity = item.quantity;
      //
      // item.referenceNumber = reference;
      // item.locationCode = productLocation;



      // orderProducts.push(orderDetailDTOs);
    }



    MOVESTOCKCART.customer.customerJson = "";


    let order = {
      // "id":MOVESTOCKCART.orderId,
      // "barCode":MOVESTOCKCART.orderId,
      // "orderTitle": this.getOrderTitle(),
      // "salesManId":MOVESTOCKCART.user.id,
      // "orderMessage":MOVESTOCKCART.orderMessage,
      // "expectedShipmentDate": MOVESTOCKCART.expectedShipmentDate,
      // "totalAmount":""+total.toFixed(2),
      // "totalTexAmount":"10",
      // "orderStatus":status,
      // "customerDTO":MOVESTOCKCART.customer,
      "productsDTO": productsDTOList,
      // "shippingServiceName":MOVESTOCKCART.shippingServiceName,
      // "shippingServiceValue":MOVESTOCKCART.shippingServiceId
    };
    //this.gVLogger.log(JSON.stringify(order));

    return productsDTOList;

  }

  clearCartProducts(){
    for(let product of MOVESTOCKCART.items){
      this.removeAll(product);
    }
    MOVESTOCKCART.items = [];
  }

  getProductsCount(){
    return MOVESTOCKCART.items.length;
  }

  getSalesManId(){
    return MOVESTOCKCART.user.id;
  }
  getCustomerName(){
    if(MOVESTOCKCART.customer !=null){

      return MOVESTOCKCART.customer.name;
    }else{
      return null;
    }
  }

  getSalesPerson(){
    return MOVESTOCKCART.user;

  }

  getADPCustomerUUID(){
    if(MOVESTOCKCART.user && MOVESTOCKCART.user.adpCustomerInfo){
      return MOVESTOCKCART.user.adpCustomerInfo.uuid;
    }else{
      return "";
    }
  }

  setShipDate(shipDate){
    MOVESTOCKCART.expectedShipmentDate = shipDate ;
  }
  // getShipDate(){
  //   return MOVESTOCKCART.expectedShipmentDate;
  // }

  // setOdId(odId){
  //   MOVESTOCKCART.odId = odId;
  // }

  // getOdId(){
  //   return MOVESTOCKCART.odId;
  // }

  // setItems(productsList){
  //   MOVESTOCKCART.items = productsList;
  // }
  setOrderId(orderId){
    MOVESTOCKCART.orderId = orderId ;
  }
  setOrderMessage(orderMessage){
    MOVESTOCKCART.orderMessage = orderMessage;
  }
  // getOrderMessage(){
  //   return MOVESTOCKCART.orderMessage;
  // }
  //
  // getExpectedSipDate(){
  //   return MOVESTOCKCART.expectedSipDate;
  // }

  getItems(){
    return MOVESTOCKCART.items;
  }


  getCustomerID(){
    if(MOVESTOCKCART.customer!=null){
      return MOVESTOCKCART.customer.id;
    }else{
      return false;
    }
  }


  // getSelectedCustomer(){
  //   return MOVESTOCKCART.customer;
  // }

  setOrderTitle(orderTitle){
    MOVESTOCKCART.orderTitle = orderTitle;
  }

  getOrderTitle(){
    return MOVESTOCKCART.orderTitle;
  }
  getOrderId(){
    return MOVESTOCKCART.orderId;
  }

  persistOrderLocal(){
    // TODO: Store the list of Cart against their user/sales persons
    let itemQuantityStatus = false;
    for(let product of MOVESTOCKCART.items){
      if(product.quantity > 0){
        itemQuantityStatus = true;
        break;
      }
    }

    if(Number(MOVESTOCKCART.items.length) > 0 && itemQuantityStatus){
      this.storage.set(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId(),MOVESTOCKCART);

    }else{
      this.unPersistOrderLocal();
    }
//this.gVLogger.log(MOVESTOCKCART);
  }
  unPersistOrderLocal(){
    this.storage.remove(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
  }

  // getPersistedOrderLocal(){
  //
  //   return this.storage.get(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
  // }

  // setCartFull(cartTemp){
  //   MOVESTOCKCART.items = cartTemp.items;
  //   MOVESTOCKCART.orderId = cartTemp.orderId;
  //   MOVESTOCKCART.orderMessage = cartTemp.orderMessage;
  //   MOVESTOCKCART.customer = cartTemp.customer;
  //   MOVESTOCKCART.orderTitle = cartTemp.orderTitle;
  //   // this.gVLogger.log("Cart Replaced...",cartTemp);
  // }


  discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }

  getOrderStatus(){
    return MOVESTOCKCART.orderStatus;
  }

  setOrderStatus(status){
    MOVESTOCKCART.orderStatus = status;
  }


  // removeJunkFromCart(){
  //   for(let item of MOVESTOCKCART.items ){
  //     // this.gVLogger.log("Item: ",item);
  //     if(item.quantity == 0 || item.quantity == '0'){
  //       // this.gVLogger.log("Item inner: ",item);
  //       var index= MOVESTOCKCART.items.map(function(x) {return x.id; }).indexOf(item.id);
  //       if (index != -1) {
  //         if(MOVESTOCKCART.items[index].quantity >= 1){
  //           MOVESTOCKCART.items[index].quantity = 0;
  //         }
  //         MOVESTOCKCART.items.splice(index, 1);
  //       }
  //     }
  //   }
  // }


  makeImageURL(dimensions,item){
    console.log("Product images url " + IMAGES_BASE_URL.imageBaseUrl + this.getSupplierUuid() +
      "/products/" +
      dimensions + "/"+
      item.productImagesDTO[0].name+
      "-" +
      dimensions +
      "." +
      item.productImagesDTO[0].extension);
    // return  IMAGES_BASE_URL + this.getADPCustomerUUID() +
    //   "/products/" +
    //   dimensions + "/"+
    //   item.productImagesDTO[0].name+
    //   "-" +
    //   dimensions +
    //   "." +
    //   item.productImagesDTO[0].extension;

    return  IMAGES_BASE_URL.imageBaseUrl + "/" + this.getSupplierUuid() +
      "/products/" +
      dimensions + "/"+
      item.productImagesDTO[0].name+
      "-" +
      dimensions +
      "." +
      item.productImagesDTO[0].extension;
  }

  getSupplierUuid(){
    return AdpCustomer.AdpCustomerInfo.uuid;
  }

  // setShippingServiceId(id){
  //   MOVESTOCKCART.shippingServiceId = id;
  // }
  // getShippingServiceId(){
  //   return MOVESTOCKCART.shippingServiceId;
  // }


  // setAdpCustomerInfo(adpCustomerInfo){
  //   AdpCustomer.AdpCustomerInfo = adpCustomerInfo;
  // }

  getAdpCustomerInfo(){
    return AdpCustomer.AdpCustomerInfo;
  }


  // sanitizeUrl(url){
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  // }



  // addToAttributeMap(key,value){
  //   attributesMap[key+""] = ""+value;
  // }

  getAttributeValue(key){
    let res = attributesMap[key+""];
    if(res === undefined){
      return "-"
    }else{
      return res;
    }
  }


  // addAttributePropertiesMap(key,val){
  //   attributesPropertiesMap.set(key+"", val);
  // }
  //
  // getAllAttributesPropertiesMap(){
  //   return attributesPropertiesMap;
  // }

  replaceDoublePipe(str){
    return str.split("||").join(" ");
  }

  ConvertToCSV(objArray) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = "";
    for (let index in objArray[0]) {
      //Now convert each value to string and comma-separated
      row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in array[i]) {
        if (line != '') line += ',';
        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  }
}



// WEBPACK FOOTER //
// ./src/providers/movestockcart-manager.ts